/*
 * @Author: lc
 * @Date: 2022-04-09 15:28:15
 * @LastEditors: lc
 * @LastEditTime: 2023-05-10 11:23:08
 * @Description: 
 */
import axios from '.././http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = '/c-api/'

const tongbupoints = {
    /** ***********普通用户BEGIN***************/
    // 列表
    list (params) {
        return axios.get(api + 'tongbupoints/list', { params: params })
    },
}

// 导出接口
export default tongbupoints
